import React from 'react'

function useStableValue<T>(value: T): T {
  const ref = React.useRef<T>(value)

  if (JSON.stringify(ref.current) !== JSON.stringify(value)) {
    ref.current = value
  }

  return ref.current
}

export default useStableValue
